,
<template>
  <div class="my_page_index" ref="my_page_index" :style="{ '--theme_color': theme_color }">
    <div v-if="page.pageStyle === 0" class="my_page_index_style1">
      <el-pagination
        v-if="$store.state.app.view_pattern === 'pc'"
        layout="prev, pager, next"
        :prev-text="getLang($t('components_my_page_my_page_index_2416'))"
        :next-text="getLang($t('components_my_page_my_page_index_2417'))"
        :current-page.sync="current"
        :page-size="Number(page.pageSize)"
        :total="total"
        @current-change="change_page"
      >
      </el-pagination>
      <div class="mb_page" v-if="$store.state.app.view_pattern === 'mb'">
        <i class="iconfont icon-jiantouzuo" :class="{disabled: current <= 1}" @click="change_prev"></i>
        <span v-if="widgetName==='searchResults'">{{ current }}</span>
        <span v-else>{{ current }} / {{ Math.ceil(total / page.pageSize) }}</span>
        <i class="iconfont icon-jiantouyou" :class="{disabled: current >= Math.ceil(total / page.pageSize)}" @click="change_next"></i>
      </div>
    </div>
    <div v-if="page.pageStyle === 1" class="my_page_index_style2">
      <el-pagination
        v-if="$store.state.app.view_pattern === 'pc'"
        layout="prev, pager, next"
        :current-page.sync="current"
        :page-size="Number(page.pageSize)"
        :total="total"
        @current-change="change_page">
      </el-pagination>
      <div class="mb_page" v-if="$store.state.app.view_pattern === 'mb'">
        <i class="iconfont icon-jiantouzuo" :class="{disabled: current <= 1}" @click="change_prev"></i>
        <span>{{ current }}</span>
        <i class="iconfont icon-jiantouyou" :class="{disabled: current >= Math.ceil(total / page.pageSize)}" @click="change_next"></i>
      </div>
      <div class="total_page">{{$t('components_my_page_my_page_index_2418', [ Math.ceil(total / page.pageSize) ])}}</div>
      <div class="jump_page">{{$t('components_my_page_my_page_index_2419')}}<my_input_int_number v-model="jumpNum" :min="1" :max="max" style="width: 60px;" @change="jump_page"></my_input_int_number>{{$t('components_my_page_my_page_index_2420')}}</div>
      <div class="confirm" v-if="$store.state.app.view_pattern === 'pc'"><el-button size="medium" @click="jump_page">{{$t('view_public_topbar_24')}}</el-button></div>
    </div>
    <div v-if="page.pageStyle === 2" class="my_page_index_style3">
      <el-button v-if="page.pageSize * current < total" class="more_btn" @click="show_more">{{$t('components_my_page_my_page_index_2421')}}<i class="el-icon-arrow-down"></i></el-button>
      <p v-else>{{$t('components_my_page_my_page_index_2422')}}</p>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

import { getTopByWindow } from '@/utils/utils.js'

export default {
  name: 'my_page_index',
  props: {
    page: {
      type: Object,
      default: () => {}
    },
    currentPage: {
      type: Number,
      defalut: 1
    },
    total: {
      type: Number,
      defalut: 0
    },
    widgetName:{
      type:String,
      defalut:''
    }
  },
  computed: {
    theme_color () {
      return this.$store.state.myRender.common.theme_color
    }
  },
  watch: {
    currentPage (val) {
      this.current = val
    },
    current (val) {
      this.scrollDom()
      this.$emit('update:currentPage', val)
    },
    'page.pageStyle' (val) {
      this.current = 1
      this.jumpNum = 1
      // this.$emit('change-page', 1)
    },
    'page.pageSize' (val) {
      this.max = Math.ceil(this.total / val)
    },
    'total' (val) {
      this.max = Math.ceil(val / this.page.pageSize)
    }
  },
  data () {
    return {
      current: this.currentPage,
      jumpNum: this.currentPage,
      jumpNumTemp: this.currentPage,
      max: Math.ceil(this.total / this.page.pageSize)
    }
  },
  methods: {
    change_page (page) {
      this.jumpNum = page
      this.current = page
      this.$emit('change-page', this.current)
    },
    jump_page () {
      if (Number(this.jumpNum) === 0) {
        this.jumpNum = 1
      }
      this.current = Number(this.jumpNum)
      this.$emit('change-page', this.current)
    },
    show_more () {
      this.current++
      this.$emit('change-page', this.current)
    },
    change_prev () {
      if (this.current > 1) {
        this.current--
      }
      this.jumpPage = this.current
      this.$emit('change-page', this.jumpPage)
    },
    change_next () {
      if (this.current < Math.ceil(this.total / this.page.pageSize)) {
        this.current++
      }
      this.jumpPage = this.current
      this.$emit('change-page', this.jumpPage)
    },
    scrollDom () {
      let dom = $(this.$refs.my_page_index).parents('.module')[0]
      let offsetTop = getTopByWindow(dom)
      let topBarHeight = $('.topBar')[0].getBoundingClientRect().height
      let myheaderHeight = $('.myheader')[0].getBoundingClientRect().height
      let marginTop = 50
      $('html,body').animate({ scrollTop: offsetTop - topBarHeight - myheaderHeight - marginTop + 'px' }, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
  .my_page_index {
    display: flex;
    justify-content: center;
    align-items: center;
    // margin-top: 10px;
    // height: 60px;
    text-align: center;
    padding-top:20px;
    padding-bottom:20px;
    /deep/ .el-pagination {
      display: flex;
      justify-content: center;
      align-items: center;
      button {
        color: #333333;
        background: transparent;
      }
      button:hover {
        color: var(--theme_color);
      }
      button:disabled {
        color: #e3e2e8;
      }
      .el-pager li {
        background: transparent;
        color: #333333;
        &.active {
          color: var(--theme_color);
        }
        &:hover {
          color: var(--theme_color);
        }
      }
    }
    /deep/ .el-button:hover {
      border-color: var(--theme_color);
      background: var(--theme_color) !important;
    }
    .my_page_index_style1 {
      /deep/ .el-pagination {
        li.number {
          font-weight: 500;
        }
      }
      .mb_page {
        display: flex;
        justify-content: center;
        align-items: center;
        // margin-top: 10px;
        // height: 60px;
        white-space: nowrap;
        font-size: 14px;
        .iconfont {
          box-sizing: border-box;
          display: inline-block;
          min-width: 35.5px;
          height: 28px;
          line-height: 28px;
          margin: 0;
          padding: 0 6px;
          background-color: transparent;
          border: none;
          color: #666;
          font-size: 14px;
          vertical-align: top;
          cursor: pointer;
          outline: 0;
          &.disabled {
            color: #e2e2e2;
          }
        }
      }
    }
    .my_page_index_style2 {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      /deep/ .el-pagination {
        color: #333333;
        button {
          width: 36px;
          height: 36px;
          line-height: 36px;
          border: 1px solid #e3e2e8;
          padding: 0;
          .el-icon {
            font-size: 14px;
          }
          &.btn-prev {
            border-right: none;
          }
          &.btn-next {
            border-left: none;
          }
        }
        li.number {
          width: 36px;
          height: 36px;
          line-height: 36px;
          border: 1px solid #e3e2e8;
          border-right: none;
          font-weight: 500;
          &:last-of-type {
            border-right: 1px solid #e3e2e8;
          }
        }
        .el-icon-more {
          height: 36px;
          line-height: 36px;
          border-left: 1px solid #e3e2e8;
        }
      }
      .mb_page {
        display: flex;
        justify-content: center;
        align-items: center;
        // margin: 0 10px;
        // height: 60px;
        white-space: nowrap;
        font-size: 14px;
        .iconfont, span {
          display: inline-block;
          width: 36px;
          height: 36px;
          line-height: 36px;
          padding: 0;
          text-align: center;
          border: 1px solid #e3e2e8;
          margin-left: -1px;
          &.disabled {
            color: #e2e2e2;
          }
        }
      }
      .total_page {
        margin: 0 10px;
        font-size: 13px;
        line-height: 36px;
        color: #333;
      }
      .jump_page {
        font-size: 13px;
        line-height: 36px;
        color: #333;
        /deep/ .el-input {
          margin: 0 5px;
          .el-input__inner {
            text-align: center;
            background: transparent;
            color: #333333;
          }
        }
      }
      .confirm {
        margin-left: 12px;
        /deep/ .el-button {
          padding: 10px 13px;
          background: transparent;
          color: #333333;
          &:hover {
            color: #ffffff;
          }
        }
      }
    }
    .my_page_index_style3 {
      font-size: 13px;
      color: #333333;
      .more_btn {
        width: 162px;
        height: 42px;
        background: transparent;
        color: #333333;
        &:hover {
          background: var(--theme_color);
          color: #ffffff;
        }
        .el-icon-arrow-down {
          margin-left: 5px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/my_page/my_page_index.vue